import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom, Subscription } from 'rxjs';
import { ArticleEnums } from 'src/app/enum/article-enums';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ArticleImportModel } from 'src/app/models/imports/article-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ArticleService } from 'src/app/services/archive/article.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-article',
  templateUrl: './import-article.component.html',
  styleUrls: ['./import-article.component.scss'],
  standalone: false
})
export class ImportArticleComponent implements OnInit {

  articleAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  articleImport: boolean = false;
  eventFile: any;
  errorArticle: number = 0;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  suscription: Subscription;
  swGeneric: number = 0;
  visibleTxt: boolean = false;

  constructor(
    private articleService: ArticleService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }


  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.swGeneric = inputs.swGeneric;
    });
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  attachFileImport() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.articleImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadGuideImport() {
    this.articleService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response:
          {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = "GuiaArticulos.docx";
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.articleAlerts || this.articleAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.articleService.exportImportErrors(this.articleAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionArtículos_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  importArticles() {
    this.articleAlerts = [];
    this.errorArticle = 0;
    this.visibleTxt = false;
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (!isPlatformBrowser(this.platformId)) return;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<ArticleImportModel>();
    let row: ArticleImportModel;
    let counter: number = 1, articleCode: number, alterCode: string | null, alterCode2: string | null, name: string, familyCode: string, groupCode: string, subgroupCode: string,
      typeArticleId: number, typeInventoryCode: number, rentalUnitCode: string, inventoryUnitCode: string, occupancyPercentageReport: boolean, daysInConstructionSiteReport: boolean,
      weight: number, areaM2: number, observation: string | null, active: boolean, swAffectsInventory: boolean, swDirectDevolutionWorkshop: boolean, swEquipmentLogbook: boolean, replacementValue: number,
      saleValue: number, cleaningValue: number, minorRepairValue: number, mayorRepairValue: number, genericCode: number | null, conceptInvoicingCode: number | null,
      swPurchase: boolean, swSale: boolean, swRequiresPurchaseOrder: boolean, swRoutine: boolean;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {
      this.articleAlerts = [];
      this.visibleTxt = false;

      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'warning',
          `El archivo ingresado no tiene registros para importar.`
        );
        return;
      }

      rows.splice(0, 1);
      rows.forEach(element => {
        counter = counter + 1;
        let rowHasError = false;
        //A. Código Artículo:
        articleCode = parseFloat(element[0] as string);
        if (isNaN(articleCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna A. El código del artículo no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //  B. Código Alterno:
        alterCode = element[1] as string;
        if (alterCode != null && alterCode.length > 20) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El código alterno supera el tamaño máximo de caracteres (20)`
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //C. Código Alterno 2:
        alterCode2 = element[2] as string;
        if (alterCode2 != null && alterCode2.length > 20) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El código alterno 2 supera el tamaño máximo de caracteres (20)`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //D. Nombre:
        name = element[3] as string;
        if (name == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El nombre no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        } else if (name.length > 300) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El nombre supera el tamaño máximo de caracteres (300)`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //E. Código Familia
        familyCode = element[4] as string;
        if (familyCode == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna E. El código de la familia no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //F. Código Grupo
        groupCode = element[5] as string;
        if (groupCode == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El código del grupo no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //G. Código Subgrupo
        subgroupCode = element[6] as string;
        if (subgroupCode == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna G. El código del subgrupo no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //H. Tipo:
        if (element[7] as string != "E" && element[7] as string != "I" && element[7] as string != "R" &&
          element[7] as string != "A" && element[7] as string != "S" && element[7] as string != "O") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna H. El tipo debe ser valores como: E / I / R / A / S / O.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }
        if (element[7] as string === "E") {
          typeArticleId = ArticleEnums.tipoEquipo;
        } else if (element[7] as string === "I") {
          typeArticleId = ArticleEnums.tipoInsumo;
        } else if (element[7] as string === "R") {
          typeArticleId = ArticleEnums.tipoReparación;
        } else if (element[7] as string === "A") {
          typeArticleId = ArticleEnums.tipoAccesorio;
        } else if (element[7] as string === "S") {
          typeArticleId = ArticleEnums.tipoServicio;
        } else {
          typeArticleId = ArticleEnums.tipoOtro;
        }

        //I. Tipo Inventario
        typeInventoryCode = element[8] as number;
        if (typeInventoryCode == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna I. El código del tipo de inventario no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        } else if (typeInventoryCode < 0 || typeInventoryCode >= 4) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna I. El tipo de inventario debe ser valores como: 0 / 1 / 2 / 3.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //J. Código Unidad Medida Alquiler
        rentalUnitCode = element[9] as string;
        if (rentalUnitCode == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna J. El código de la unidad medida alquiler no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //K. Código Unidad Medida Inventario
        inventoryUnitCode = element[10] as string;
        if (inventoryUnitCode == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna K. El código de la código unidad medida inventario no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //L. Porcentaje de Utilización:
        if (element[11] as string != "S" && element[11] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna L. El campo porcentaje de utilización debe ser valores como: S / N.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }
        occupancyPercentageReport = element[11] as string === "S";

        //M. Días en Obra:
        if (element[12] as string != "S" && element[12] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna M. El campo días en obra debe ser valores como: S / N.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }
        daysInConstructionSiteReport = element[12] as string === "S";

        //N. Afecta Inventario:
        if (element[13] as string != "S" && element[13] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna N. El campo Afecta Inventario debe ser valores como: S / N.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }
        swAffectsInventory = element[13] as string === "S";

        //O. Devolución Directa Taller:
        if (element[14] as string != "S" && element[14] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna O. El campo Devolución Directa a Taller debe ser valores como: S / N.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }
        swDirectDevolutionWorkshop = element[14] as string === "S";

        //P. Hoja de vida:
        if (element[15] as string != "S" && element[15] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna P. El campo Hoja de vida debe ser valores como: S / N.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }
        swEquipmentLogbook = element[15] as string === "S";

        //Q. Peso:
        weight = parseFloat(element[16] as string);
        if (isNaN(weight)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna Q. El peso del artículo no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //R. M2:
        areaM2 = parseFloat(element[17] as string);
        if (isNaN(areaM2)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna R. El areaM2 del artículo no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //S. Valor Reposición:
        replacementValue = parseFloat(element[18] as string);
        if (isNaN(replacementValue)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna S. El valor de reposición del artículo no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //T. Valor Venta:
        saleValue = parseFloat(element[19] as string);
        if (isNaN(saleValue)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna T. El valor de venta del artículo no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //U. Valor Limpieza:
        cleaningValue = parseFloat(element[20] as string);
        if (isNaN(cleaningValue)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna U. El valor de limpieza del artículo no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //V. Valor Reparacion Menor:
        minorRepairValue = parseFloat(element[21] as string);
        if (isNaN(minorRepairValue)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna V. El valor de reparación menor del artículo no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //W. Valor Reparacion Mayor:
        mayorRepairValue = parseFloat(element[22] as string);
        if (isNaN(mayorRepairValue)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna W. El valor de reparación mayor del artículo no es válido.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //X. Observación:
        observation = element[23] as string;
        if (observation != null && observation.length > 1000) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna X. La observación supera el tamaño máximo de caracteres (1000)`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //Y. Estado:
        if (element[24] as string != "A" && element[24] as string != "I") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna Y. El campo estado debe ser valores como: A / I.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }
        active = element[24] as string === "A";

        //Z. Código Genérico:
        if (element[25] != null) {
          genericCode = parseFloat(element[25] as string);
          if (isNaN(genericCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna Z. El código del articulo genérico no es válido.`;
            this.articleAlerts.push(alert);
            rowHasError = true;
          }
        } else {
          genericCode = null;
        }

        //AA. Código Concepto Compra:
        if (element[26] != null) {
          conceptInvoicingCode = parseFloat(element[26] as string);
          if (isNaN(conceptInvoicingCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna AA. El código del concepto de compra no es válido.`;
            this.articleAlerts.push(alert);
            rowHasError = true;
          }
        } else {
          conceptInvoicingCode = null;
        }

        //AB. Venta:
        if (element[27] != null && element[27] as string != "S" && element[27] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna AB. El campo Venta debe ser valores como: S / N.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }
        swSale = element[27] as string === "S";

        //AC. Compra:
        if (element[28] != null && element[28] as string != "S" && element[28] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna AC. El campo Compra debe ser valores como: S / N.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }
        swPurchase = element[28] as string === "S";

        //AD. Requiere Orden de Compra:
        if (element[29] != null && element[29] as string != "S" && element[29] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna AD. El campo Requiere Orden de Compra debe ser valores como: S / N.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }
        swRequiresPurchaseOrder = element[29] as string === "S";
        //sin compra no puede requerir orden de compra
        if (swRequiresPurchaseOrder && !swPurchase) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna AD. No se puede marcar Requiere Orden de Compra si el artículo no es de Compra.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        //AE. Rutina:
        if (element[30] != null && element[30] as string != "S" && element[30] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna AE. El campo Rutina debe ser valores como: S / N.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }
        swRoutine = element[30] as string === "S";
        //Sin hoja de vida no puede requerir rutina
        if (swRoutine && !swEquipmentLogbook) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna AE. No se puede marcar Rutina si el artículo no tiene Hoja de Vida.`;
          this.articleAlerts.push(alert);
          rowHasError = true;
        }

        if (!rowHasError) {
          row = new ArticleImportModel(counter, articleCode, alterCode, alterCode2, name, familyCode, groupCode, subgroupCode, typeArticleId,
            typeInventoryCode, rentalUnitCode, inventoryUnitCode, occupancyPercentageReport, daysInConstructionSiteReport, weight, areaM2, observation, active,
            swAffectsInventory, swDirectDevolutionWorkshop, swEquipmentLogbook, replacementValue, saleValue, cleaningValue, minorRepairValue, mayorRepairValue, genericCode,
            conceptInvoicingCode, swPurchase, swSale, swRequiresPurchaseOrder, swRoutine);
          rowsImports.push(row);
        } else {
          isOk = false;
        }
      });

      if (!isOk || rowsImports.length === 0) {
        this.errorArticle = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
        this.clearInputFile();
        return;
      }

      await this.processImportArticles(rowsImports);
    });
  }

  async processImportArticles(rowsImports: Array<ArticleImportModel>) {
    try {
      const response = await firstValueFrom(this.articleService.importArticles(rowsImports, this.swGeneric));
      this.loadPreInvoicingModel = response;
      this.articleAlerts = response?.alerts ?? [];
      this.errorArticle = response?.preInvoicingStateId;
      if (this.errorArticle === 1) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea.',
          'ERROR'
        );
      } else if (this.articleAlerts.length > 0) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con alertas, puede exportarlas si lo desea'
        );
      } else {
        this.visibleTxt = false;
        this.articleImport = true;
        this.toastHandlerService.showToast(
          'success',
          `La importación terminó exitosamente.`
        );
        this.close();
      }
      this.clearInputFile();
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Artículos.', error);
    }
  }
}
